import axios from "../api/api"
import { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";

const GETDATABYID = "/api/maharaj"

const MaharajModal = ({ show, setShow, id, setId }) => {
    const [content, Setcontent] = useState([])

    useEffect(() => {
        const getdatabyid = async () => {
            if (show === true) {
                const response = await axios.get(`${GETDATABYID}/${id}`)
                const data = response?.data?.maharaj
                console.log(data)
                Setcontent(data)
            } else {
                Setcontent([])
            }
        }
        getdatabyid()
    }, [id])

    // Handle hide
    const handleHide = () => {
        setId(null);
        setShow(false);
    }



    return (
        <Modal show={show} onHide={handleHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Maharaj Details -{content?.hindiname} </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {
                    content?.status === "published" ? <strong className="text-capitalize text-green">{content?.status}  </strong> : <strong className="text-capitalize text-red">{content?.status} on {content?.scheduledate} </strong>  
                }
                <Table bordered striped hover>
                    <tbody>
                        <tr>
                            <th className="w-25">English Name</th>
                            <td>{content?.englishname}</td>
                        </tr>
                        <tr>
                            <th className="w-25">Content</th>
                            <td>{content?.content}</td>
                        </tr>
                        {
                            content?.image?.map((item, i) => (
                                <tr key={i}>
                                    <th className="w-25">Image File</th>
                                    <td><img src={item?.location} className="m-4" /><br /> <a href={item?.location} className="btn btn-primary " target="_blank">Click To Download</a></td>

                                </tr>
                            ))
                        }
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    )
}

export default MaharajModal;